export const REPORTING_DATA_LOAD_SUCCESS = 'REPORTING_DATA_LOAD_SUCCESS';
export const REPORTING_DATA_LOAD_FAILURE = 'REPORTING_DATA_LOAD_FAILURE';
